import { render, staticRenderFns } from "./viewTrainees.vue?vue&type=template&id=10bd755c&scoped=true&"
import script from "./viewTrainees.vue?vue&type=script&lang=js&"
export * from "./viewTrainees.vue?vue&type=script&lang=js&"
import style0 from "./viewTrainees.vue?vue&type=style&index=0&id=10bd755c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bd755c",
  null
  
)

export default component.exports